<template>
  <div class="container-fluid mt-4">
    <b-card v-if="userIsLoggedIn">
      <b-card-header style="height: 75px;">
        <b-row>
          <b-col lg="9">
            <h1 class="h1"> Experimente </h1>
          </b-col>
          <b-col lg="3">
            <b-alert style="margin-top: 5px;" :show="loading" variant="info">Lädt Daten...</b-alert>
          </b-col>
        </b-row>
      </b-card-header>
      <ul class="nav nav-tabs" style="margin-top: 20px;">
        <li v-for="(content, tab) in tabNames" :key="tab" v-bind:class="{ active: ($route.params.experiment === tab) }">
          <a> <b-nav-item :to="'/exudats/' + tab"> {{ content.titleSingular }} </b-nav-item> </a>
        </li>
      </ul>
      <div class="tab-content">
        <router-view />
      </div>
    </b-card>
    <div v-else>
      <NotLoggedIn />
    </div>
  </div>
</template>

<script>
import config from '../config.json'
import NotLoggedIn from './NotLoggedIn'
import mixins from '../mixins/table_mixins'
// import $ from 'jquery'

export default {
  components: {
    NotLoggedIn
  },
  mixins: [mixins],
  data () {
    return {
      tabNames: config.exudats
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Exudats.vue